export const loginUser = async (data) => {
  let newEntry = await fetch(`${process.env.API_URL}/users/login`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...data, action: 'login' }),
  }).then((r) => r.json());
  return newEntry.data;
};

export const requestPasswordReset = async (data) => {
  let newEntry = await fetch(`${process.env.API_URL}/users/request-password-reset`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...data }),
  }).then((r) => r.json());
  return newEntry.data;
};

export const resetUserPassword = async (data) => {
  let newEntry = await fetch(`${process.env.API_URL}/users/reset-password`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...data }),
  }).then((r) => r.json());
  return newEntry.data;
};

export const getUser = async ({ queryKey }) => {
  const [_key, { id }] = queryKey;
  let data = await fetch(`${process.env.API_URL}/users/${id}`).then((r) => r.json());
  return data.data;
};

export const verifyIdentity = async ({ queryKey }) => {
  const [_key, { email, password }] = queryKey;
  let response = await fetch(`${process.env.API_URL}/users/login`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password, action: 'verifyIdentity' }),
  }).then((r) => r.json());
  return response.data;
};

export const addStudent = async ({ data }) => {
  let newEntry = await fetch(`${process.env.API_URL}/users`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};

export const updateUser = async ({ data, id }) => {
  let newEntry = await fetch(`${process.env.API_URL}/users/${id}`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};

export const getUserTeams = async ({ queryKey }) => {
  const [_key, { email, type }] = queryKey;
  let response = await fetch(`${process.env.API_URL}/users/${email}/teams`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, type }),
  }).then((r) => r.json());
  // console.log(response.data);
  return response.data;
};

export const getUserReadMessages = async ({ queryKey }) => {
  const [_key, { id, token }] = queryKey;
  let response = await fetch(`${process.env.API_URL}/users/${id}/messages`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }).then((r) => r.json());
  return response.data;
};

export const markMessageRead = async ({ data }) => {
  let newEntry = await fetch(`${process.env.API_URL}/users/${data.user}/messages`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${data.token}`,
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};
